module.exports = __webpack_public_path__ + "static/media/phone-02.57fbf449.png";